module.exports = __webpack_public_path__ + "img/recipes.1bf056f5.jpeg";